import React, { useRef, useState, useEffect } from 'react';
import {
   Button,
   ListGroup,
   Overlay,
   Popover,
   Row,
   Col,
} from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import {
   showEgTable,
   downloadExcel,
   getFiles,
   downloadErrorLogs,
   downloadHSNLogs,
} from "../../slices/fileUploadReducer";
import { setScreenView } from "../../slices/commonReducer";
import { useParams, Link } from 'react-router-dom';
import { HiMiniReceiptRefund } from "react-icons/hi2";
import { FaDownload } from "react-icons/fa";


function EgmHeaders({ headerType }) {
   const dispatch = useDispatch();
   const [show, setShow] = useState(false);
   const { folder_id } = useParams();


   const {
       gridView
   } = useSelector((state) => state.common);


   const {
       show_eg_icon,
       error_count,
       processed_count,
       total_file_count,
       show_tab,
   } = useSelector((state) => state.files);


   const target = useRef(null);
   const popoverRef = useRef(null);


   const handleBack = () => {
       dispatch(getFiles({ folder_id, page: 1 }));
       dispatch(setScreenView("grid"));
       dispatch(showEgTable(false));
   };


   const handleDownload = () => {
       setShow(false);
       const is_refund = headerType === 'refunds' ? 1 : undefined;
       dispatch(downloadExcel({ folder_id, is_refund }));
   };


   const handleErrorLogs = () => {
       setShow(false);
       const is_refund = headerType === 'refunds' ? 1 : undefined;
       dispatch(downloadErrorLogs({ folder_id, is_refund }));
   };


   const handleHSN = () => {
       setShow(false);
       const is_refund = headerType === 'refunds' ? 1 : undefined;
       dispatch(downloadHSNLogs({ folder_id, is_refund }));
   };


   // Hide dropdown when clicking outside
   useEffect(() => {
       const handleClickOutside = (event) => {
           if (
               popoverRef.current &&
               !popoverRef.current.contains(event.target) &&
               target.current &&
               !target.current.contains(event.target)
           ) {
               setShow(false);
           }
       };


       if (show) {
           document.addEventListener('mousedown', handleClickOutside);
       }


       return () => {
           document.removeEventListener('mousedown', handleClickOutside);
       };
   }, [show]);


   // Custom Popover Content
   const CustomPopover = React.forwardRef(({ style, ...props }, ref) => (
       <div
           ref={(node) => {
               popoverRef.current = node;
               if (typeof ref === 'function') ref(node);
               else if (ref) ref.current = node;
           }}
           {...props}
           style={style}
       >
           <Popover
               className="download-overlay"
               id="popover-download"
               style={{
                   backgroundColor: "#ffffff",
                   padding: "0px",
                   boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                   borderRadius: "8px",
                   minWidth: "210px",
                    marginLeft: "-6em",

               }}
           >
               <Popover.Body className="pt-0">
                   <div className="d-flex flex-column">
                       <Button
                           variant="light"
                           className="text-start d-flex align-items-center mb-1"
                           style={{ color: "#000" }}
                           onClick={handleDownload}
                       >
                           <i className="ri-folder-add-line me-3"></i> Download Excel
                       </Button>
                       <Button
                           variant="light"
                           className="text-start d-flex align-items-center mb-1"
                           style={{ color: "#000" }}
                           onClick={handleErrorLogs}
                       >
                           <i className="ri-folder-add-line me-3"></i> Download Error Logs
                       </Button>
                       <Button
                           variant="light"
                           className="text-start d-flex align-items-center"
                           style={{ color: "#000" }}
                           onClick={handleHSN}
                       >
                           <i className="ri-folder-add-line me-3"></i> Download HSN
                       </Button>
                   </div>
               </Popover.Body>
           </Popover>
       </div>
   ));


   return (
       <Row className="justify-content-between align-items-center bg-gray-100 rounded-lg p-3 shadow-sm m-1">
           <Col md={6} sm={1} className={`${show_eg_icon ? 'd-flex justify-content-start p-0 gap-10' : ''}`}>
               {gridView === "egm" && (
                   <Button
                       variant="link"
                       onClick={handleBack}
                       className="group d-flex align-items-center justify-content-start p-0 px-3 py-2 hover:[background-color:#0061FE] rounded transition"
                       style={{ textDecoration: 'none' }}
                   >
                       <i className="ri-arrow-left-line group-hover:text-white transition"></i>
                       <span className="ms-2 group-hover:text-white transition">
                           Exit to Files
                       </span>
                   </Button>
               )}


               {show_eg_icon && (
                   <>
                       <div className="d-flex gap-5 align-items-center">
                           <div
                               className="group d-flex flex-column align-items-center p-0 m-0 hover:[background-color:#0061FE] rounded px-3 py-2 transition cursor-pointer"
                               style={{ width: '104px' }}
                               onClick={() => dispatch(showEgTable(true))}
                           >
                               <HiMiniReceiptRefund
                                   size={25}
                                   className="transition text-[#0061FE] group-hover:text-white"
                               />
                               <span
                                   className="mt-1 text-[#0061FE] text-center transition group-hover:text-white "
                                   style={{ fontSize: '18px', whiteSpace: 'nowrap' }}
                               >
                                   Process Bill
                               </span>
                           </div>


                           <Button
                               ref={target}
                               variant="link"
                               onClick={() => setShow(!show)}
                               className="group d-flex flex-column align-items-center p-0 m-0 hover:[background-color:#0061FE] rounded px-3 py-2 transition"
                               style={{ width: '90px', textDecoration: 'none' }}
                           >
                               <FaDownload
                                   size={25}
                                   className="transition text-[#0061FE] group-hover:text-white"
                               />
                               <span
                                   className="mt-1 text-center transition group-hover:text-white"
                                   style={{ fontSize: '18px', whiteSpace: 'nowrap' }}
                               >
                                   Download
                               </span>
                           </Button>
                       </div>


                       {target.current && (
                           <Overlay target={target.current} show={show} placement="bottom">
                               {(props) => <CustomPopover {...props} />}
                           </Overlay>
                       )}
                   </>
               )}
           </Col>


           {(!!folder_id || show_tab) && (
               <Col md={6} className='text-end d-flex flex-column align-items-end'>
                   {!!folder_id && (
                       <div id="extnVerifier">
                           This system is missing its supporting software <Link to="/instructions">Download Now</Link>
                       </div>
                   )}
                   {show_tab && (
                       <ListGroup horizontal className="justify-content-end">
                           <ListGroup.Item>{total_file_count} files processed</ListGroup.Item>
                           <ListGroup.Item>{processed_count} processed</ListGroup.Item>
                           <ListGroup.Item>{error_count} error</ListGroup.Item>
                       </ListGroup>
                   )}
               </Col>
           )}
       </Row>
   );
}


export default EgmHeaders;


